import React from 'react';
import {
  DashboardOutlined,
  FileAddOutlined,
  FileOutlined,
  MessageOutlined,
  NotificationOutlined,
  UserOutlined,
  SettingOutlined,
  BulbOutlined,
  ShoppingOutlined,
  WarningOutlined,
  RocketOutlined,
} from '@ant-design/icons';

export interface SidebarNavigationItem {
  title: string;
  key: string;
  url?: string;
  children?: SidebarNavigationItem[];
  icon?: React.ReactNode;
  roles?: string[];
}

export const sidebarNavigation: SidebarNavigationItem[] = [
  {
    title: 'Analytics',
    key: 'dashboard',
    url: '/',
    icon: <DashboardOutlined />,
    roles: ['Admin'],
  },
  {
    title: 'common.users',
    key: 'users',
    url: '/users',
    icon: <UserOutlined />,
    roles: ['Admin', 'Support'],
  },
  {
    title: 'Shopify Orders',
    key: 'shopifyOrders',
    url: '/shopify-orders',
    icon: <ShoppingOutlined />,
    roles: ['Admin', 'Support'],
  },
  {
    title: 'Lost & Stolen',
    key: 'flaggedSerials',
    url: '/flagged-serials',
    icon: <WarningOutlined />,
    roles: ['Admin', 'Support'],
  },
  {
    title: 'Feedback',
    key: 'feedback',
    url: '/feedback',
    icon: <MessageOutlined />,
    roles: ['Admin', 'Support'],
  },
  {
    title: 'common.content',
    key: 'content',
    url: '/content',
    icon: <FileAddOutlined />,
    roles: ['Admin', 'Support'],
  },
  {
    title: 'common.notification',
    key: 'notification',
    url: '/notification',
    icon: <NotificationOutlined />,
    roles: ['Admin', 'Support'],
  },
  {
    title: 'Feature Requests',
    key: 'featureRequests',
    url: '/feature-requests',
    icon: <FileOutlined />,
    roles: ['Admin', 'Support'],
  },
  {
    title: 'Firmwares',
    key: 'firmwares',
    url: '/firmwares',
    icon: <SettingOutlined />,
    roles: ['Admin', 'Support'],
  },
  {
    title: 'Daily Tips',
    key: 'tips',
    url: '/tips',
    icon: <BulbOutlined />,
    roles: ['Admin', 'Support'],
  },
  {
    title: 'Releases',
    key: 'releases',
    url: '/releases',
    icon: <RocketOutlined />,
    roles: ['Admin', 'Support'],
  },
];
